import React, { type ReactElement } from 'react'
import { Typography } from '@mui/material'
import { useNavigate } from 'react-router'
import ThemeButton, { BUTTON_VARIANTS } from 'common/ui/theme-button/ThemeButton'

import styles from './PageNotFound.module.scss'

const PageNotFound: React.FC = (): ReactElement => {
  const navigate = useNavigate()

  return (
    <div className={styles.container}>
      <Typography variant="title6">Tražena stranica nije pronađena.</Typography>
      <ThemeButton
        variant={BUTTON_VARIANTS.outlined}
        onClick={() => {
          navigate('/')
        }}
      >
        Nazad na početnu stranicu
      </ThemeButton>
    </div>
  )
}

export default PageNotFound
